import React from "react";

/** PM prototype Check (shared.jsx) — simple stroke tick for verified pills. */
export const StrokeCheckIcon: React.FC<{
  size?: number;
  className?: string;
}> = ({ size = 9, className }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 12 12"
    fill="none"
    aria-hidden="true"
    className={className}
  >
    <path
      d="M2.5 6.5L5 9l4.5-5.5"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default StrokeCheckIcon;
